"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DefaultVideoStreamIdSet_1 = require("../videostreamidset/DefaultVideoStreamIdSet");
/**
 * [[AllHighestVideoBandwidthPolicy]] implements is a rudimentary policy that simply
 * always subscribes to the highest quality video stream available
 * for all non-self participants.
 */
var AllHighestVideoBandwidthPolicy = /*#__PURE__*/function () {
  function AllHighestVideoBandwidthPolicy(selfAttendeeId) {
    _classCallCheck(this, AllHighestVideoBandwidthPolicy);
    this.selfAttendeeId = selfAttendeeId;
    this.reset();
  }
  _createClass(AllHighestVideoBandwidthPolicy, [{
    key: "reset",
    value: function reset() {
      this.optimalReceiveSet = new DefaultVideoStreamIdSet_1.default();
      this.subscribedReceiveSet = new DefaultVideoStreamIdSet_1.default();
      this.videoSources = undefined;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      this.videoIndex = videoIndex;
      this.optimalReceiveSet = this.calculateOptimalReceiveSet(videoIndex);
    }
  }, {
    key: "updateMetrics",
    value: function updateMetrics(_clientMetricReport) {}
  }, {
    key: "wantsResubscribe",
    value: function wantsResubscribe() {
      return !this.subscribedReceiveSet.equal(this.optimalReceiveSet);
    }
  }, {
    key: "chooseSubscriptions",
    value: function chooseSubscriptions() {
      this.subscribedReceiveSet = this.optimalReceiveSet.clone();
      return this.subscribedReceiveSet.clone();
    }
  }, {
    key: "chooseRemoteVideoSources",
    value: function chooseRemoteVideoSources(videoSources) {
      this.videoSources = videoSources;
      this.optimalReceiveSet = this.calculateOptimalReceiveSet(this.videoIndex).clone();
    }
  }, {
    key: "calculateOptimalReceiveSet",
    value: function calculateOptimalReceiveSet(videoIndex) {
      var streamSelectionSet = new DefaultVideoStreamIdSet_1.default();
      if (!this.videoIndex || this.videoIndex.allStreams().empty()) {
        return streamSelectionSet;
      }
      var receiveSet = videoIndex.highestQualityStreamFromEachGroupExcludingSelf(this.selfAttendeeId);
      // If video sources are not chosen, then return the default receive set.
      if (this.videoSources === undefined) {
        return receiveSet;
      }
      // Get the list of all the remote stream information
      var remoteInfos = this.videoIndex.remoteStreamDescriptions();
      var mapOfAttendeeIdToOptimalStreamId = new Map();
      var _iterator = _createForOfIteratorHelper(remoteInfos),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var info = _step.value;
          if (receiveSet.contain(info.streamId)) {
            mapOfAttendeeIdToOptimalStreamId.set(info.attendeeId, info.streamId);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(this.videoSources),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var videoSource = _step2.value;
          var attendeeId = videoSource.attendee.attendeeId;
          if (mapOfAttendeeIdToOptimalStreamId.has(attendeeId)) {
            streamSelectionSet.add(mapOfAttendeeIdToOptimalStreamId.get(attendeeId));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return streamSelectionSet;
    }
  }]);
  return AllHighestVideoBandwidthPolicy;
}();
exports.default = AllHighestVideoBandwidthPolicy;